<script setup lang="ts"></script>

<template>
	<Container
		class="bg-secondary"
		main-class="grid grid-cols-1 gap-5 md:grid-cols-4"
	>
		<div class="col-span-2 h-[280px] space-y-5">
			<Skeleton is-active class="mb-3 h-8 w-2/3 bg-white last:w-1/2" />

			<Skeleton
				v-for="skeleton in 7"
				:key="`region-content-skeleton-${skeleton}`"
				is-active
				class="h-4 w-full bg-white last:w-1/2"
				variant="white"
			/>
		</div>
		<Skeleton is-active class="col-span-2 h-[280px] bg-white" variant="white" />
		<Skeleton is-active class="col-span-2 h-[280px] bg-white" variant="white" />
		<Skeleton is-active class="col-span-1 h-[280px] bg-white" variant="white" />
		<Skeleton is-active class="col-span-1 h-[280px] bg-white" variant="white" />
	</Container>
</template>
